import { ReactElement } from "react"
import { useRecoilValue, useRecoilState } from "recoil"
import { useWatchParty } from "../../../hooks/useWatchParty"
import { productOverlaySelector } from "../../../recoil/atoms/product-overlay"
import { BarPlayer } from "./controls-player/bar-player"
import {
  brandingSelector,
  showTabsAtBottomOnMobileSelector
} from "../../../recoil/atoms/room"
import layoutStates from "../../../recoil/atoms/layout"
import PlayerPanel from "./controls-player/player-panel"
import { showRHSLeaveButtonSelector } from "../../../recoil/selectors/layoutSelectors/layout-selectors"
import { useIsModLive } from "../../../hooks/useIsModLive"
import { useCurrentAvatarInfo } from "src/conditionals/Avatar"
import { Flex } from "@chakra-ui/react"
import usePlayerVisibility from "src/recoil/atoms/player/usePlayerVisibility"

type MediaControllerProps = {
  isMobile: boolean
  isLandscape: boolean
  showLeaveOverlay: boolean
  isTablet?: boolean
  children: ReactElement
}

export const MediaController = ({
  isMobile,
  isLandscape,
  showLeaveOverlay,
  isTablet = false,
  children
}: MediaControllerProps) => {
  const modIsLive = useIsModLive()
  const [{ isOpen }] = useRecoilState(productOverlaySelector)
  const isFloatingDivActive = useRecoilValue(layoutStates.isFloatingDivActive)
  const roomStyles = useRecoilValue(brandingSelector)

  const { avatarId } = useCurrentAvatarInfo()
  const showAvatar = !!avatarId || roomStyles.enableDigitalAvatar

  const showTabsAtBottomOnMobile =
    useRecoilValue(showTabsAtBottomOnMobileSelector) && !showAvatar
  const { isWatchParty: isWP } = useWatchParty()
  const isWatchParty = isWP && !showAvatar

  const handleStopPropagation = event => {
    event.stopPropagation()
  }

  // show leave button below heart icon on desktop only if user don't have mic, cam or share permission
  const showLeaveButtonOnRHS = useRecoilValue(showRHSLeaveButtonSelector)

  // Show drag to resize icon only on mobile in portrait mode
  const showDragToResizeIcon = isMobile && !isLandscape && !isTablet

  // show leave button on player controller, if UI is rendered on mobile or leave button should be displayed on RHS
  const showLeaveButton = (isMobile && !isTablet) || showLeaveButtonOnRHS

  const hideControls = isWatchParty || isFloatingDivActive || isOpen

  const { isPlayerVisible } = usePlayerVisibility()

  return (
    <Flex
      width={"100%"}
      position="absolute"
      bottom="0"
      zIndex={1000000}
      visibility={hideControls ? "hidden" : "unset"}
      // transition={"all 0.5s"}  // For smooth animation
      onClick={handleStopPropagation}
      transform={
        isPlayerVisible
          ? "translateY(100%) translateY(-50px)"
          : "translateY(100%)"
      }
      // This element is refactor - old css will be found in custom-player.styled.ts Control
    >
      <Flex dir="column">
        {children}

        {/* Show 100% process bar when tab is render at bottom and on mobile*/}
        {showTabsAtBottomOnMobile && isMobile && (
          <BarPlayer
            handleOnChange={() => {}}
            values={[100]}
            showThumb={false}
          />
        )}
      </Flex>
      <PlayerPanel
        isMobile={isMobile}
        showLeaveButton={showLeaveButton}
        showDragToResizeIcon={showDragToResizeIcon}
        // Hide the Live icon and local speaker if the avatar is enabled.
        showLiveIcon={modIsLive && !showAvatar}
        showLocalSpeakerIcon={modIsLive && !showAvatar}
        // CM(utta/ls)
        showAvatarSpeakerIcon={showAvatar}
        showAvatarMicIcon={showAvatar}
      />
    </Flex>
  )
}
